import React from 'react';
import { IconProps } from '.';

const SvgColoredFingerOne = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#EC8A3C'
        d='M18.9 11.34c-.19-.19-.6-.46-1.07-.72l-1.42-1.49-1.57 1.49h-.43l-1.87-2.71c-1.03 0-1.86.85-1.85 1.87L8.04 8.21C7.43 8.48 7 9.09 7 9.8v.72l-3 3.11v1.63l7.45 8s7.84-11.39 7.86-11.37c-.1-.17-.38-.52-.42-.54l.01-.01Z'
      />
      <path
        fill='#FFD653'
        d='M17.83 1.5c0-.83-.68-1.5-1.5-1.5s-1.5.68-1.5 1.5v9.13h3V1.5Zm-3.43 9.13V9.11c0-.82-.68-1.48-1.5-1.48s-1.48.68-1.48 1.5v1.5h2.98ZM5.43 9.09h.13c.79 0 1.43.64 1.43 1.43v3.1c0 .79-.64 1.43-1.43 1.43h-.13c-.79 0-1.43-.64-1.43-1.43v-3.1c0-.79.64-1.43 1.43-1.43Zm5.16 2.21-.04.05c-.35.39-.58.9-.58 1.47 0 .05 0 .09.01.14.03.51.23.96.54 1.32-.05.1-.12.18-.19.26-.27.31-.66.51-1.11.51-.82 0-1.49-.67-1.49-1.49V9.09A1.496 1.496 0 0 1 9.22 7.6c.82 0 1.49.67 1.49 1.49v2.07s-.08.09-.12.14Z'
      />
      <path
        fill='#FFD653'
        d='M5.54 15.8c.76 0 1.43-.39 1.83-.99.09.14.2.26.32.37.88.83 2.26.78 3.11-.06.11-.11.23-.23.31-.36.15.08.35.3 1.1.3h1.89c-.28.21-.53.46-.76.75-.92 1.09-1.5 2.69-1.5 4.47a.37.37 0 1 0 .74 0c0-1.9.71-3.56 1.77-4.47.55-.47 1.18-.75 1.86-.75.53.06.63-.75.09-.75h-4.1c-.82 0-1.49-.67-1.49-1.49s.67-1.49 1.49-1.49h5.96c.64 0 1.24.44 1.43 1.05l.81 2.67c.08.25.36 1.39.31 1.63 0 3.58-3.5 7.31-7.76 7.31-4.88.01-8.83-3.89-8.94-8.74h.01c.38.34.88.55 1.42.55H5.54Z'
      />
    </svg>
  );
};

export default SvgColoredFingerOne;
